export default "__VITE_ASSET__BaA8ZtrU__"